export const transformKeys = (
  object: Record<string, any>,
  transform: (key: string) => string
): Record<string, any> =>
  Object.keys(object).reduce((newObject, key) => {
    const newKey = transform(key);
    newObject[newKey] = object[key];

    return newObject;
  }, {});
